import React from 'react';
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
export const LoadingScreen = ({ spacing, style, children, size }) => {
    return (React.createElement(Grid, { container: true, direction: "column", alignItems: "center", spacing: spacing === undefined ? 4 : spacing, sx: Object.assign({ padding: '20% 0' }, style) },
        React.createElement(Grid, { item: true },
            React.createElement(CircularProgress, { size: size })),
        children && React.createElement(Grid, { item: true }, children)));
};
